// extracted by mini-css-extract-plugin
export default {"mobile":"_3j3KN","root":"_2Tjve","onImage":"_2mvbX"};